<script>
import Multiselect from "vue-multiselect";

export default {
  name: 'RMultiselect',
  components: {Multiselect},
  props: {
    value: null,
    options: {default: []},
    simple: {type: Boolean, default: false},
    loading: {type: Boolean, default: false},
    taggable: {type: Boolean, default: false},
    internalSearch: {type: Boolean, default: true},
    preserveSearch: {type: Boolean, default: false},
    showLabels: {type: Boolean, default: true},
    resetAfter: {type: Boolean, default: false},
    allowEmpty: {type: Boolean, default: true},
    multiple: {type: Boolean, default: false},
    groupSelect: {type: Boolean, default: false},
    groupLabel: {type: String, default: null},
    groupValues: {type: String, default: null},
    trackBy: {type: String, default: 'value'},
    label: {type: String, default: 'label'},
    customLabel: null,
    limit: {type: Number, default: 99999},
    optionsLimit: {type: Number, default: 99999},
    placeholder: {
      type: String,
      default: 'Sélectionnez une option'
    }
  },
  data() {
    return {
      local: this.value
    };
  },
  methods: {
    tag(v) {
      this.$emit('tag', v);
    },
    searchChange(v) {
      this.$emit('search-change', v);
    },
    clear() {
      this.local = null;
    }
  },
  watch: {
    local(v) {
      this.$emit('input', v);
    }
  }
};
</script>

<template>
  <multiselect v-model="local" :options="options" :loading="loading" :show-labels="false" :taggable="taggable"
               :track-by="simple ? null : trackBy" :label="simple ? null : label" :internalSearch="internalSearch"
               :showLabels="showLabels" :preserveSearch="preserveSearch" :limit="limit" :optionsLimit="optionsLimit"
               :groupSelect="groupSelect" :groupValues="groupValues" :groupLabel="groupLabel" :allowEmpty="allowEmpty"
               :customLabel="customLabel" :resetAfter="resetAfter" :multiple="multiple"
               :placeholder="placeholder" tagPlaceholder="Appuyer sur entrée pour créer une option"
               @tag="tag" @search-change="searchChange">
    <template #caret>
      <div v-if="value" class="multiselect__clear" @click="clear">
        <i class="bx bxs-x-circle"></i>
      </div>
      <div v-else class="multiselect__select" style=""></div>
    </template>

    <template #noOptions="props">
      La liste est vide
    </template>

    <template #noResult="props">
      Aucun résultat
    </template>

    <template #singleLabel="props">
      <slot name="singleLabel" v-bind:props="props"></slot>
    </template>

    <template #option="props">
      <slot name="option" v-bind:props="props"></slot>
    </template>
  </multiselect>
</template>